
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiClear as ObiClearElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-clear.js';
 
 
 

 
 export const ObiClear = createComponent({
   react: React,
   tagName: 'obi-clear',
   elementClass: ObiClearElement,
   events: {
     
   }
  });
 
 